export const TOURNAMENT_TIME_ZONE = 'Africa/Lagos';

export function formatTournamentDateTime(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('en-NG', {
    timeZone: TOURNAMENT_TIME_ZONE,
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
}

export function formatTournamentDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('en-NG', {
    timeZone: TOURNAMENT_TIME_ZONE,
    dateStyle: 'medium',
  }).format(date);
}

export function toTournamentInstant(value) {
  if (!value) return value;
  // datetime-local has no timezone. Tournament admin input is explicitly WAT.
  const normalized = String(value).length === 16 ? `${value}:00` : String(value);
  const instant = new Date(`${normalized}+01:00`);
  if (Number.isNaN(instant.getTime())) throw new Error('Invalid Nigeria tournament date/time');
  return instant.toISOString();
}

export function toTournamentLocalInput(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: TOURNAMENT_TIME_ZONE,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(date).reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}
